export default __webpack_public_path__ + "static/media/twitter.9ef71e8b.svg";